


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const addAudioNoteREd = function(state = initialState, action) {
switch (action.type) {
case Actions.ADD_AUDIO_NOTE:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.ADD_AUDIO_NOTE_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.ADD_AUDIO_NOTE_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
